import styled from 'styled-components';
import { commonGameImageCssMixin } from '../game-image/game-image.default.box';

const DefaultBox = styled.div`
  ${commonGameImageCssMixin};
  height: 100%;
`;

export const GameImageAnimatedDefaultBox = DefaultBox;